import curry from "../../../../lib/core/functional/curry";

import {
    authorization,
    extraField,
    feedback,
    goto,
    privacyPolicy,
    submit,
    successMessage,
    userInfo,
    afterSignup,
    otp,
    otpFeedback,
} from "./views";

function prepareModuleWithDefaults(module, defaultParams, form, wrapper, params) {
    const newParams = { ...defaultParams, ...params };
    return module(form, wrapper, newParams);
}

const applyDefaultParamsOn = curry(prepareModuleWithDefaults);

export const loginModules = {
    goto,
    feedback,
    authorization: applyDefaultParamsOn(authorization, {
        password: true,
        confirm_password: false,
        autogenerate_password: false,
    }),
    submit: applyDefaultParamsOn(submit, { caption: "Log In" }),
};

export const signupModules = {
    goto,
    feedback,
    success_message: successMessage,
    user_info: userInfo,
    privacy_policy: privacyPolicy,
    extra_field: extraField,
    authorization: applyDefaultParamsOn(authorization, { password: true }),
    submit: applyDefaultParamsOn(submit, { caption: "Sign Up" }),
    after_signup: afterSignup,
};

export const resetModules = {
    goto,
    feedback,
    authorization: applyDefaultParamsOn(authorization, {
        password: false,
        confirm_password: false,
    }),
    submit: applyDefaultParamsOn(submit, { caption: "Reset Password" }),
};

export const otpModules = {
    otp_form: applyDefaultParamsOn(otp, { caption: "Submit" }),
    feedback: otpFeedback,
}
